import { useState } from 'react'
import { Column } from 'react-table'
import { ICaseHistory } from '../../../../../../app/entities/CaseHistory'
import Table from '../../../../global/components/table/Table'
import TableTopper from '../../../../global/components/table/helpers/table-topper/TableTopper'
import TableTitle from '../../../../global/components/table/helpers/table-title/TableTitle'

interface ICaseHistoryProps {
  caseHistory: ICaseHistory[]
}

export default function CaseHistoryTable({ caseHistory }: ICaseHistoryProps) {
  const [isOpen, setIsOpen] = useState(false)

  // Sort by statusDate descending (most recent first) and memoize
  const sortedHistory = [...caseHistory].sort((a, b) => {
    const dateA = new Date(a.statusDate).getTime()
    const dateB = new Date(b.statusDate).getTime()
    return dateB - dateA
  })

  const columns: Column<ICaseHistory>[] = [
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ value }) => {
        return (
          <>
            {value ? (
              <div>
                {value
                  .split('_')
                  .filter(Boolean)
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() +
                      word.slice(1).toLowerCase(),
                  )
                  .join(' ')}
              </div>
            ) : (
              <div>{'N/A'}</div>
            )}
          </>
        )
      },
    },
    {
      Header: 'Status Date',
      accessor: 'statusDate',
      Cell: ({ value }) => {
        return (
          <>
            {value ? (
              <div>
                {new Date(value).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }) + ' '}
                {new Date(value).toLocaleDateString()}
              </div>
            ) : (
              <div>{'N/A'}</div>
            )}
          </>
        )
      },
    },
    {
      Header: 'Username',
      accessor: 'username',
      Cell: ({ value }) => {
        return <div>{value || 'Unknown User'}</div>
      },
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <TableTopper
        isOpen={isOpen}
        onToggleClick={() => setIsOpen(!isOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <TableTitle>Case History Table</TableTitle>
        </div>
      </TableTopper>
      <Table
        columns={columns}
        data={sortedHistory as any}
        isLoading={false}
        onRowClick={() => {}}
        isOpen={isOpen}
        isDisplayMode={true}
        disableAllRowClicks={true}
        maxHeight={'200px'}
      />
    </div>
  )
}
